const styles = (theme) => ({
  titleRow: {
    gap: theme.spacing(1),
  },
  description: {
    marginTop: theme.spacing(1),
  },
});

export default styles;
